export default {
  belongClass:[{
    value:"basicCard",
    label:"基础会员卡"
  },{
    value:"individualTimeCard",
    label:"私教包时卡"
  },{
    value:"individualLesson",
    label:"私教课"
  },{
    value:"leagueLesson",
    label:"团课"
  },{
    value:"trainingCamp",
    label:"训练营"
  }],
  belongClassText:(value) => {
    let text = "";
    this.a.belongClass.forEach(item => {
      if(item.value == value){
        text = item.label;
      }
    })
    return text;
  },
  timeUnit:[{
    value:"1",
    label:"天"
  },{
    value:"2",
    label:"月"
  },{
    value:"3",
    label:"年"
  }],
  timeUnitText:(value) => {
    let text = "";
    this.a.timeUnit.forEach(item => {
      if(item.value == value){
        text = item.label;
      }
    })
    return text;
  },
  refundRule:[{
    value:"1",
    label:"不支持退款"
  },{
    value:"2",
    label:"购买后7天内可退"
  }],
  refundRuleText:(value) => {
    let text = "";
    this.a.refundRule.forEach(item => {
      if(item.value == value){
        text = item.label;
      }
    })
    return text;
  },
  publishStatus:[{
    value:"1",
    label:"立即上架"
  },{
    value:"0",
    label:"下架"
  }],
  publishStatusText:(value) => {
    let text = "";
    this.a.publishStatus.forEach(item => {
      if(item.value == value){
        text = item.label;
      }
    })
    return text;
  },
  isWorkStatus:[{
    value:"1",
    label:"已上线"
  },{
    value:"0",
    label:"待发布"
  },{
    value:"2",
    label:"已下线"
  }],
  isWorkStatusText:(value) => {
    let text = "";
    this.a.isWorkStatus.forEach(item => {
      if(item.value == value){
        text = item.label;
      }
    })
    return text;
  },
}



// WEBPACK FOOTER //
// ./src/global/global.js